import { create as createPlaybackWebPlayer } from 'playback-web-player';

const createPlayer = (parentElement, { behaviour, analytics }) =>
    createPlaybackWebPlayer(parentElement, {
        behaviour: {
            fullscreenElement: behaviour.fullscreenElement,
            fallbackImageUrl: behaviour.fallbackImageUrl,
        },
        analytics: {
            convivaCustomerKey: analytics.convivaCustomerKey,
            enable: true,
        },
    });

export default createPlayer;
